import { visuallyHidden } from '@mui/utils';
import { Box, TableCell, TableSortLabel, Typography } from "@mui/material";
import { AppColors } from 'resources/AppColors';

function TableHeaderCell({ column, sortColumn, sortDirection, onSort }) {
  const createSortHandler = (property) => (event) => {
    onSort(event, property);
  };

  return (
    <TableCell align="left" >
      {!column.isSortable ?
        <Typography variant='subtitle_bold' sx={{ color: AppColors.PRIMARY }}>{column.label}</Typography>
        : (
          <TableSortLabel
            active={sortColumn === column.id}
            direction={sortColumn === column.id ? sortDirection : 'asc'}
            onClick={createSortHandler(column.id)}
          >
            <Typography variant='subtitle_bold' sx={{ color: AppColors.PRIMARY }}>{column.label}</Typography>

            {sortColumn === column.id ? (
              <Box component="span" sx={visuallyHidden}>
                {sortDirection === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>
        )}
    </TableCell>
  );
}

export default TableHeaderCell